/**
 * Single helper to resolve a stored upload path (`/uploads/...`) to a browser
 * URL. Derives the app base from Vite's BASE_URL (e.g. `/tenis/` in production)
 * instead of hardcoding `/tenis`, so the same code works on a subpath deploy and
 * a root-domain deploy. Absolute URLs and non-upload values pass through.
 */

const appBasePath = import.meta.env.BASE_URL.replace(/\/$/, "");

export function uploadAssetHref(value: string | null | undefined): string | null {
  if (!value) return null;
  if (/^https?:\/\//i.test(value)) return value;
  if (value.startsWith("/uploads/")) return `${appBasePath}${value}`;
  return value;
}
